import {
  AR_DEFAULT_WAITING_ON_OPTIONS,
  ProductModule,
  type ArCollectionWaitingOnOption,
} from '@erp/shared-types';
import {
  useWaitingOnOptions,
  type WaitingOnOptionsSource,
} from '@/components/common/waiting-on/useWaitingOnOptions';

/**
 * AR collections' binding into the shared waiting-on machinery: the Set Next
 * Step reasons live at `ar.collections.waitingOnOptions` on the AR module
 * config and fall back to the seeded AR taxonomy. Mirrors
 * `AR_COLLECTION_WAITING_ON_SOURCE` on the backend, which validates against
 * the same list.
 */
export const AR_COLLECTION_WAITING_ON_SOURCE: WaitingOnOptionsSource = {
  module: ProductModule.AR_INVOICING,
  readConfiguredOptions: (config) => config?.ar?.collections?.waitingOnOptions,
  defaultOptions: AR_DEFAULT_WAITING_ON_OPTIONS,
};

/**
 * The org's "waiting on" options for collection threads, including disabled
 * ones (stored keys on old threads must keep resolving to labels). Filter on
 * `enabled` for pickers.
 */
export function useCollectionWaitingOnOptions(): ArCollectionWaitingOnOption[] {
  return useWaitingOnOptions(AR_COLLECTION_WAITING_ON_SOURCE);
}
